var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolonezMapCenterIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA0029",
    d: "M24 20a8 8 0 0 0 5.6569-2.3431 8.0005 8.0005 0 0 0 0-11.3137 8.0001 8.0001 0 0 0-11.3138 11.3137A8 8 0 0 0 24 20m0 0v24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA0029",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M24 20a8 8 0 0 0 5.6569-2.3431 8.0005 8.0005 0 0 0 0-11.3137 8.0001 8.0001 0 0 0-11.3138 11.3137A8 8 0 0 0 24 20Zm0 0v24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolonezMapCenterIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/polonez-map-center-icon.a5a145a040c2bc0687abf54bc50e2876.svg";